module.exports = __webpack_public_path__ + "static/media/Team_08.03506249.png";